(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var btn = document.querySelector('.announcement-bar__close');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var bar = document.querySelector('.announcement-bar');
    if (bar) bar.style.display = 'none';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  var toggle = document.getElementById('nav-toggle');
  var close = document.getElementById('nav-close');
  var overlay = document.getElementById('nav-overlay');
  var nav = document.getElementById('mobile-nav');

  function openNav() {
    nav.classList.add('is-open');
    overlay.classList.add('is-open');
    nav.removeAttribute('aria-hidden');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    nav.classList.remove('is-open');
    overlay.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openNav);
  close.addEventListener('click', closeNav);
  overlay.addEventListener('click', closeNav);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(() => {
  const root = document.documentElement;
  const form = document.getElementById('pdp-product-form');
  if (!form) return;

  const mainImg = document.querySelector('[data-pdp-main-image]');
  const hiddenId = form.querySelector('[data-pdp-variant-id]');
  const priceEl = document.querySelector('[data-pdp-price]');
  const stickyPriceEl = document.querySelector('[data-pdp-sticky-price]');

  // --- Gallery thumbnails ---
  // Click a thumb: swap main image src + srcset, update aria-current
  document.querySelectorAll('[data-pdp-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.full;
      const srcset = thumb.dataset.srcset || '';
      if (mainImg && src) {
        mainImg.src = src;
        if (srcset) {
          mainImg.srcset = srcset;
        } else {
          mainImg.removeAttribute('srcset');
        }
      }
      document.querySelectorAll('[data-pdp-thumb]').forEach(t => {
        const isCurrent = t === thumb;
        t.setAttribute('aria-current', isCurrent ? 'true' : 'false');
        t.classList.toggle('pdp-gallery__thumb--active', isCurrent);
      });
    });
  });

  // --- Color swatches ---
  // Click a swatch: update hidden variant id, swap main gallery, update price displays,
  // update aria-checked and selected class.
  // Note: data-variant-price is already money-formatted (e.g. "$42.00") — set directly as text.
  document.querySelectorAll('[data-pdp-swatch]').forEach(sw => {
    sw.addEventListener('click', () => {
      const vid = sw.dataset.variantId;
      const vimg = sw.dataset.variantImage;
      const vprice = sw.dataset.variantPrice;

      if (hiddenId && vid) {
        hiddenId.value = vid;
      }

      if (vimg && mainImg) {
        mainImg.src = vimg;
        mainImg.removeAttribute('srcset');
      }

      if (vprice) {
        if (priceEl) priceEl.textContent = vprice;
        if (stickyPriceEl) stickyPriceEl.textContent = vprice;
      }

      document.querySelectorAll('[data-pdp-swatch]').forEach(b => {
        const isSelected = b === sw;
        b.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        b.classList.toggle('pdp-swatch--selected', isSelected);
      });
    });
  });

  // --- Size pill radios ---
  // On change: update hidden variant id input.
  // The radio checked state is handled natively by the browser (input type=radio).
  document.querySelectorAll('[data-pdp-size]').forEach(inp => {
    inp.addEventListener('change', () => {
      if (inp.checked && hiddenId && inp.dataset.variantId) {
        hiddenId.value = inp.dataset.variantId;
      }
    });
  });

  // --- Quantity stepper ---
  const qtyInput = document.querySelector('[data-pdp-qty-input]');
  const qtyDecrement = document.querySelector('[data-pdp-qty-decrement]');
  const qtyIncrement = document.querySelector('[data-pdp-qty-increment]');

  if (qtyDecrement && qtyInput) {
    qtyDecrement.addEventListener('click', () => {
      const current = parseInt(qtyInput.value, 10);
      if (current > 1) {
        qtyInput.value = current - 1;
      }
    });
  }

  if (qtyIncrement && qtyInput) {
    qtyIncrement.addEventListener('click', () => {
      const current = parseInt(qtyInput.value, 10);
      qtyInput.value = current + 1;
    });
  }

  // --- Sticky ATC — IntersectionObserver ---
  // Watch the inline .pdp-atc button. When it leaves viewport → show sticky bar.
  // When it re-enters → hide sticky bar.
  // The sticky submit button uses form="pdp-product-form" HTML attribute for submission —
  // no JS needed to submit; this handler only controls visibility.
  // Progressive enhancement: if IntersectionObserver is unavailable, sticky never shows
  // and the inline ATC remains the only CTA (acceptable fallback).
  const inlineAtc = document.querySelector('.pdp-atc');
  if (inlineAtc && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          root.classList.toggle('pdp-sticky--visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px', threshold: 0 }
    );
    stickyObserver.observe(inlineAtc);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
